module.exports = {
    theme: {
        extend: {
            colors: {
                palette: {
                    orange: '#ff6322',
                    lightorange: '#ff9402',
                    red: '#f50345',
                    lightgray: '#f5f5f7',
                    darkgray: '#2f3542',
                    footertextgray: '#bdbdbd',
                    newsgray: '#717171',
                    bloggray: '#F9FAFB',
                },
            },
        },
        fontFamily: {
            outfit: ['Outfit', 'sans-serif'],
        },
    },

    plugins: [
        require('@tailwindcss/aspect-ratio'),
        require('@tailwindcss/typography'),
        require('@tailwindcss/line-clamp'),
        require('@tailwindcss/forms'),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
    ],
};
